
function AboutTeamComponent() {
    return (
      <div className="ErrorComponent">
        <h1>AboutTeamComponent</h1>
        <div>AboutTeamComponent</div>
      </div>
    )
  }   
  
  
    export default AboutTeamComponent;  